import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenZmsPage } from '@/features/product/pages/SpecimenZmsPage';
import { specimenZmsSearchSchema } from '@/features/product/types/product.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/product/specimen-distribution/$specimenId/')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: specimenZmsSearchSchema,
  component: function SpecimenZmsRoute() {
    const { specimenId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Specimen Distribution ZMs">
        <Suspense fallback={<PageLoader />}>
          <SpecimenZmsPage specimenId={specimenId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
